import React from 'react'
import { createBrowserRouter } from 'react-router-dom'
import App from '../App'

import AuthLayout from '../layouts/auth-layout'
import AuthNoLayout from '../layouts/auth-no-layout'
import CornerstoneLayout from '../layouts/cornerstone/primary-layout'
import NotFoundPage from '../pages/not-found'
import MaintenancePage from '../pages/maintenance'
import { routes } from './routes'

export const cornerstoneRouter = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        element: <AuthLayout />,
        children: [
          {
            path: routes.login.path,
            lazy: () => import('../pages/sign-in')
          }
        ]
      },
      {
        element: <AuthNoLayout />,
        children: [
          {
            path: routes.maintenance.path,
            element: <MaintenancePage />
          },
          {
            path: routes.signin.path,
            lazy: () => import('../pages/sign-in-completion')
          },
          {
            path: routes.internalLogin.path,
            lazy: () => import('../pages/admin-internal-login')
          }
        ]
      },
      {
        element: <CornerstoneLayout />,
        children: [
          {
            path: routes.cornerstoneArticle.path,
            lazy: () => import('../pages/location')
          }
        ]
      },
      {
        path: '*',
        element: <NotFoundPage />
      }
    ]
  }
])
